let offcanvasToggles = document.querySelectorAll('.offcanvas-toggle');
let offcanvas = document.querySelector('.offcanvas');
let body = document.querySelector('body');

for (const item of offcanvasToggles) {
    item.addEventListener("click", () => {

        if (offcanvas.classList.contains('is-open')) {
            offcanvas.classList.remove('is-open');
            body.classList.remove('m-offcanvas-scroll-lock');
        } else {
            offcanvas.classList.add('is-open');
            body.classList.add('m-offcanvas-scroll-lock');
        }
    })
};
